import example from './images/example.png'
import { Form, OverlayTrigger, Popover } from 'react-bootstrap'
import './IncidentItemAlerts.scss'

type ComponentProps = {
  alertCount:string
}

const IncidentItemAlerts = (props:ComponentProps) => {

  const renderIncidentItemAlerts:any = () => (
    <Popover id={'incident-item-alerts-popover'}>
      <Popover.Header className='incident-item-alerts-popover-header'>Opmærksomhedspunkter</Popover.Header>
      <Popover.Body className='incident-item-alerts-popover-body'>
        <img id='example-image' title='Eksempel' alt='' src={example} />       
      </Popover.Body>
    </Popover>
  )

  const handleXYZ = (event:any) => {
    hidePopover('incident-item-alerts-popover')
  }

  const hidePopover = (popoverID: string) => {
    const popover = document.getElementById(popoverID)
    popover?.style.setProperty('display', 'none')
  }

  return (
    // <OverlayTrigger trigger={['click']} rootClose={true} placement='auto' overlay={renderIncidentItemAlerts()}>
      <div id='incident-item-alerts'>
        {props.alertCount}
      </div>
    // </OverlayTrigger>
  )
}

export default IncidentItemAlerts
